/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useCallback, useEffect, useRef } from 'react';
import { Middleware, SWRHook } from 'swr';

export const laggyMiddleWare: Middleware = (useSWRNext: SWRHook) => (key, fetcher, config) => {
	const laggyDataRef = useRef<any>(null);

	const swr = useSWRNext(key, fetcher, config);

	useEffect(() => {
		if (swr.data !== undefined) {
			laggyDataRef.current = swr.data;
		}
	}, [swr.data]);

	const resetLaggy = useCallback(() => {
		laggyDataRef.current = undefined;
	}, []);

	const dataOrLaggyData = swr.data === undefined ? laggyDataRef.current : swr.data;

	const isLagging = swr.data === undefined && laggyDataRef.current !== undefined;

	return Object.assign({}, swr, {
		data: dataOrLaggyData,
		isLagging,
		resetLaggy,
		isLoading: swr.isLoading,
	});
};
